// extracted by mini-css-extract-plugin
export default {"container":"Main_container__CBKFy","div1":"Main_div1__ikc3Q","div3":"Main_div3__OS9UF","div2":"Main_div2__k+bDq"};